module.exports = __webpack_public_path__ + "media/reskin-images/icon--chevron-right-89264452.svg";